import { ONBOARDING_THREAD_ID } from '@/utils/constants';

export const onboardingMessagesFR = {
  'step-0': {
    messages: {
      role: 'ai',
      content: [],
    },
  },
  'step-1': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-0',
          timestamp: '2024-11-21T06:35:39.224335+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Quels conducteurs nécessitent un accompagnement en raison d’une note globale moyenne inférieure à 70 au cours du mois dernier, et quelles sont leurs notes ?',
        },
        {
          id: 'onb-1',
          timestamp: '2024-11-21T06:36:09.224354+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
            x_axis: 'Nom du conducteur',
          },
          content:
            'Voici les conducteurs ayant une note globale moyenne inférieure à 70 pour le mois de juin 2026 (du 1er juin 2026 au 30 juin 2026). Cette analyse couvre 12 conducteurs nécessitant un accompagnement.\n\n' +
            '```json\n\n' +
            '{"table": [{"Nom du conducteur": "Lucas Auernhammer", "Note globale moyenne (%)": 23.0}, {"Nom du conducteur": "Christian Scheunemann", "Note globale moyenne (%)": 25.0}, {"Nom du conducteur": "Bruno Ranft", "Note globale moyenne (%)": 26.0}, {"Nom du conducteur": "Ute Meyjohann", "Note globale moyenne (%)": 26.0}, {"Nom du conducteur": "Erhard Brauer", "Note globale moyenne (%)": 28.0}, {"Nom du conducteur": "Margit Br\\u00fcck", "Note globale moyenne (%)": 28.0}, {"Nom du conducteur": "Torsten Mustermann", "Note globale moyenne (%)": 39.0}, {"Nom du conducteur": "Marius Mehl", "Note globale moyenne (%)": 42.0}, {"Nom du conducteur": "Thomas Mustermann", "Note globale moyenne (%)": 43.0}, {"Nom du conducteur": "Bernd M\\u00fcller", "Note globale moyenne (%)": 44.0}, {"Nom du conducteur": "Maik Fleischhauer", "Note globale moyenne (%)": 44.0}, {"Nom du conducteur": "Sabine Lindenmann", "Note globale moyenne (%)": 48.0}]}\n```' +
            '\n\n' +
            '**Conducteurs nécessitant une attention prioritaire (note inférieure à 30) :**\n\n' +
            'Les conducteurs Lucas Auernhammer, Christian Scheunemann, Bruno Ranft, Ute Meyjohann, Erhard Brauer et Margit Brück affichent les notes les plus basses de la flotte, toutes inférieures à 30. Ces conducteurs devraient être prioritaires pour un accompagnement individuel intensif.\n\n' +
            "**Conducteurs avec des marges d'amélioration significatives (note entre 39 et 48) :**\n\n" +
            "Torsten Mustermann, Marius Mehl, Thomas Mustermann, Bernd Müller, Maik Fleischhauer et Sabine Lindenmann présentent des notes comprises entre 39 et 48. Bien qu'ils soient au-dessus du groupe précédent, leurs performances restent nettement en dessous du seuil de 70 et méritent un suivi régulier.\n\n" +
            '**Recommandations :**\n\n' +
            '- Un accompagnement ciblé via le programme **MAN ProfiDrive** ou le **Connected CoDriver** peut aider ces conducteurs à améliorer leur style de conduite et leur efficacité.\n\n' +
            "- Il est conseillé d'analyser les sous-notes (freinage, conduite en roue libre, régulateur de vitesse, excès de vitesse) pour identifier les axes d'amélioration spécifiques à chaque conducteur.",
        },
      ],
    },
  },

  'step-2': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-2',
          timestamp: '2024-11-21T06:36:39.224360+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Quelle est la raison de la faible note de Lucas Auernhammer?',
        },
        {
          id: 'onb-3',
          timestamp: '2024-11-21T06:37:09.224366+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Voici les notes détaillées de Lucas Auernhammer pour la période du 1er juin 2026 au 30 juin 2026.\n\n' +
            '```json\n\n' +
            '{"table": [{"KPI": "Nom du conducteur", "": "Lucas Auernhammer"}, {"KPI": "Note globale", "": 23.0}, {"KPI": "Note de roulage en roue libre", "": 20.0}, {"KPI": "Note du comportement de freinage", "": 20.0}, {"KPI": "Note de la p\\u00e9dale d\'acc\\u00e9l\\u00e9rateur", "": 40.0}, {"KPI": "Note d\'utilisation du r\\u00e9gulateur de vitesse", "": 50.0}, {"KPI": "Note d\'exc\\u00e8s de vitesse", "": 0.0}]}\n```' +
            '\n\n' +
            'Les résultats montrent que Lucas Auernhammer obtient une note globale de 23,0, ce qui le place parmi les conducteurs nécessitant une attention prioritaire.\n\n' +
            "Les points les plus préoccupants sont la note d'excès de vitesse (0,0), la note de roulage en roue libre (20,0) et la note du comportement de freinage (20,0), qui sont particulièrement basses.\n\n" +
            "La note de la pédale d'accélérateur (40,0) et la note d'utilisation du régulateur de vitesse (50,0) sont légèrement meilleures, mais restent bien en dessous d'un niveau satisfaisant.\n\n" +
            'Pour améliorer ces performances, un accompagnement individuel via le programme **MAN ProfiDrive** ou le **Connected CoDriver** est fortement recommandé, en ciblant notamment la gestion de la vitesse, l’anticipation au freinage et l’utilisation de la conduite en roue libre.',
        },
      ],
    },
  },

  'step-3': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-4',
          timestamp: '2024-11-21T06:37:39.224372+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Comment la performance de freinage est-elle calculée?',
        },
        {
          id: 'onb-5',
          timestamp: '2024-11-21T06:38:09.224378+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'La performance de freinage est calculée selon deux critères principaux :\n\n' +
            '**1. Rapport frein sans usure / frein de service**\n\n' +
            '- **Note 100 %** : rapport de 5:1 ou plus (frein sans usure vs frein de service) **et** moins de 1 % de la distance totale freinée via le frein de service.\n\n' +
            '- **Note 0 %** : rapport de 0,5:1 ou moins **et** plus de 5,5 % de la distance freinée via le frein de service.\n\n' +
            '**2. Principe général**\n\n' +
            'Plus un conducteur utilise le frein sans usure (frein moteur, ralentisseur) par rapport au frein de service, meilleure est sa note.\n\n' +
            'La distance totale parcourue est également prise en compte dans le calcul.\n\n' +
            'Basé sur les documents suivants :\n\n' +
            '1. [eTGS eTruck Manuel du chauffeur - Page 93](https://fleetassistant.rio.cloud/docs/language=FR/market=all/eTGS_eTruck_Manuel_du_chauffeur.pdf#page=93)\n' +
            '2. [eTGX eTruck Manuel du chauffeur - Page 85](https://fleetassistant.rio.cloud/docs/language=FR/market=all/eTGX_eTruck_Manuel_du_chauffeur.pdf#page=85)\n' +
            '3. [Perform Webinar 1 FR - Page 4](https://fleetassistant.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=4)\n' +
            '4. [Perform Évaluation du conducteur 1 FR - Page 3](https://fleetassistant.rio.cloud/docs/language=FR/market=all/Perform_Fahrerbewertung_1_FR.pdf#page=3)\n' +
            '5. [Perform Webinar 1 FR - Page 6](https://fleetassistant.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=6)',
        },
      ],
    },
  },

  'step-4': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-6',
          timestamp: '2024-11-21T06:38:39.224384+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Que peut faire mon conducteur Lucas Auernhammer, qui a une faible note de freinage, pour s’améliorer?',
        },
        {
          id: 'onb-7',
          timestamp: '2024-11-21T06:39:09.224403+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            "Sur la période du 21 juillet 2026 au 20 août 2026, Lucas Auernhammer affiche une note de comportement de freinage de **20/100**, ce qui est très faible et indique un réel potentiel d'amélioration.\n\n" +
            '- **KPI** Nom du conducteur: Lucas Auernhammer\n' +
            '- **KPI** Note du comportement de freinage: 20.0\n\n' +
            'Voici ce que Lucas peut concrètement mettre en place pour progresser :\n\n' +
            '**1. Privilégier les freins sans usure**\n\n' +
            'Le problème central est très probablement une utilisation excessive du frein de service au lieu du frein moteur et du ralentisseur. Pour rappel, une note de 100 % est atteinte lorsque le rapport frein sans usure / frein de service est supérieur ou égal à 5:1 et que moins de 1 % de la distance est freinée via le frein de service. À l’inverse, une note de 0 % correspond à un rapport inférieur ou égal à 0,5:1 avec plus de 5,5 % de la distance freinée au frein de service. Avec 20/100, Lucas se situe encore très proche du seuil bas : le frein moteur et le ralentisseur doivent devenir ses premiers réflexes pour ralentir.\n\n' +
            '**2. Anticiper davantage**\n\n' +
            '- Maintenir une distance de sécurité suffisante avec le véhicule précédent.\n' +
            '- Lire la route en avance : panneaux, feux, ronds-points, descentes et trafic.\n' +
            '- Adapter son allure à la circulation, aux conditions météorologiques et au profil de la route.\n\n' +
            '**3. Freiner progressivement**\n\n' +
            'Lorsque le recours au frein de service est inévitable, il doit être actionné progressivement et non brusquement. Cela réduit l’impact négatif sur la note et améliore la sécurité globale.\n\n' +
            '**4. Suivre sa progression semaine après semaine**\n\n' +
            'Lucas peut consulter ses notes partielles régulièrement pour observer l’évolution du ratio frein sans usure / frein de service et identifier les situations où il sollicite encore trop le frein de service.\n\n' +
            '**5. Formation MAN ProfiDrive**\n\n' +
            'Un accompagnement via une session de formation MAN ProfiDrive peut lui permettre d’ancrer ces bonnes pratiques de conduite préventive et d’optimiser durablement son comportement au freinage.\n\n' +
            'La réponse a été générée à partir des documents suivants (classés par pertinence) :\n\n' +
            '1. [Perform Webinar 1 FR - Page 5](https://fleetassistant.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=5)\n' +
            '2. [eTGS eTruck Manuel du chauffeur - Page 93](https://fleetassistant.rio.cloud/docs/language=FR/market=all/eTGS_eTruck_Manuel_du_chauffeur.pdf#page=93)\n' +
            '3. [eTGX eTruck Manuel du chauffeur - Page 85](https://fleetassistant.rio.cloud/docs/language=FR/market=all/eTGX_eTruck_Manuel_du_chauffeur.pdf#page=85)\n' +
            '4. [Perform Évaluation du conducteur 1 FR - Page 3](https://fleetassistant.rio.cloud/docs/language=FR/market=all/Perform_Fahrerbewertung_1_FR.pdf#page=3)\n' +
            '5. [TGX Manuel du chauffeur - Page 644](https://fleetassistant.rio.cloud/docs/language=FR/market=all/TGX_Manuel_du_chauffeur.pdf#page=644)',
        },
      ],
    },
  },
};
